import {
  CertificateType,
  CommodityTransactionStatus,
  ExportRequestStatus,
  ExportSummaryQuery,
  VintageHalf,
} from "@/app/types/generated/graphql";

export const exportRequestByIdQuery = {
  read(_: any) {
    return demoMretsExportSummary;
  },
};

export const demoMretsExportSummary: ExportSummaryQuery["exportRequestById"] = {
  id: "1",
  exportNumber: "EX-2023-0001",
  requestedOn: "2023-05-15T10:00:00Z",
  completedOn: "2023-05-20T10:00:00Z",
  totalVolume: 1000,
  status: ExportRequestStatus.Success,
  statusMessage: `Completed Export Successfully`,
  exportRequestDetails: [
    {
      __typename: "ExportRequestDetail",
      id: "c1",
      volume: 1000,
      status: ExportRequestStatus.Success,
      statusMessage: "Commodity exported successfully",
      attributes: {
        __typename: "MretsRecAttributes",
        vintage: 2022,
        vintageHalf: VintageHalf.FrontHalf,
        location: "AL",
        fuelSources: ["WND", "HYD"],
        eligibilities: ["ia_aep", "ia"],
        project: "Chipmunk-Solar",
        certifications: ["CRS"],
        commencementDate: "2022-01-01",
        certificateType: CertificateType.R,
      },
      commodityTransactions: [
        {
          __typename: "CommodityTransaction",
          id: "t1",
          status: CommodityTransactionStatus.Success,
          statusMessage: "Transaction verified",
          volume: 1000,
          commoditySerial: {
            __typename: "CommoditySerial",
            serialPrefix: "CS",
            serialFrom: "0001",
            serialTo: "1000",
          },
          generator: {
            id: "g1",
            crsEffectiveDate: "2023-05-15",
            crsExpiryDate: "2023-10-15",
          },
        },
        {
          __typename: "CommodityTransaction",
          id: "t2",
          status: CommodityTransactionStatus.Success,
          statusMessage: "Transaction pending verification",
          volume: 1000,
          commoditySerial: {
            __typename: "CommoditySerial",
            serialPrefix: "CS",
            serialFrom: "1001",
            serialTo: "2000",
          },
          generator: {
            id: "g1",
          },
        },
      ],
    },
  ],
};

export const demoErcotExportSummary: ExportSummaryQuery["exportRequestById"] = {
  id: "1",
  exportNumber: "EX-2023-0001",
  requestedOn: "2023-05-15T10:00:00Z",
  completedOn: "2023-05-20T10:00:00Z",
  totalVolume: 1000,
  status: ExportRequestStatus.Success,
  statusMessage: `Completed Export Successfully`,
  exportRequestDetails: [
    {
      __typename: "ExportRequestDetail",
      id: "c1",
      volume: 1000,
      status: ExportRequestStatus.Success,
      statusMessage: "Commodity exported successfully",
      attributes: {
        __typename: "ErcotRecAttributes",
        vintage: 2022,
        vintageHalf: VintageHalf.Q1,
        certifications: ["CRS"],
        fuelSources: ["GT"],
        project: "GHG Emission Control",
        location: "TX",
        certificateType: CertificateType.Cp,
      },
      commodityTransactions: [
        {
          __typename: "CommodityTransaction",
          id: "t1",
          status: CommodityTransactionStatus.Success,
          statusMessage: "Transaction verified",
          volume: 1000,
          commoditySerial: {
            __typename: "CommoditySerial",
            serialPrefix: "CS",
            serialFrom: "0001",
            serialTo: "1000",
          },
          generator: {
            id: "g1",
            crsEffectiveDate: "2023-05-15",
            crsExpiryDate: "2023-10-15",
          },
        },
        {
          __typename: "CommodityTransaction",
          id: "t2",
          status: CommodityTransactionStatus.Success,
          statusMessage: "Transaction pending verification",
          volume: 1000,
          commoditySerial: {
            __typename: "CommoditySerial",
            serialPrefix: "CS",
            serialFrom: "1001",
            serialTo: "2000",
          },
          generator: {
            id: "g1",
          },
        },
      ],
    },
  ],
};
